import { CommunicationApi } from "communication-adaptor-api";
import { createCommonConfigurationForApis } from "./CommunicationCommonHelper";
import { spire360ApiClient } from "./Spire360ApiClient";
import { AxiosInstance } from "axios";

export function communicationApi(): CommunicationApi {
  const basePath = process.env.REACT_APP_COMMUNICATION_API_URL;
  const axiosInstance: AxiosInstance = spire360ApiClient;
  return new CommunicationApi(
    undefined,
    // "http://localhost:5099"
    `${process.env.REACT_APP_COMMUNICATION_API_URL}`,
    axiosInstance
  );
}
